import { CommonData } from "../../datastructures/gamestate/gameData";

export class BlackoutWheel
{
    private activeGameData:CommonData;
    private radius:number;
    private animationDuration:number;
    private parentContainer: PIXI.Container;
    private darkenBodyLeft:PIXI.Graphics;
    private darkenBodyLeftFadeTween:PIXI.tween.Tween;
    private darkenBodyLeftMask:PIXI.Graphics;
    private darkenBodyLeftMaskTween:PIXI.tween.Tween;        
    private darkenBodyRight:PIXI.Graphics;
    private darkenBodyRightFadeTween:PIXI.tween.Tween;
    private darkenBodyRightMask:PIXI.Graphics;
    private darkenBodyRightMaskTween:PIXI.tween.Tween;
    
    constructor(radius:number,activeGameData:CommonData)
    {   
        this.activeGameData=activeGameData;
        this.radius=radius+2;
        this.animationDuration=2000;//defaultspeed
        this.parentContainer= new PIXI.Container();
        this.darkenBodyLeft;//graphics
        // this.darkenBodyLeftsprite;
        this.darkenBodyLeftFadeTween;
        this.darkenBodyLeftMask;
        this.darkenBodyLeftMaskTween;        
        this.darkenBodyRight;
        // this.darkenBodyRightsprite;
        this.darkenBodyRightFadeTween;
        this.darkenBodyRightMask;
        this.darkenBodyRightMaskTween;
        

        this.create();
    }
    private create=():void=>
    {
        

        //Create left part animation
        this.darkenBodyLeft= new PIXI.Graphics();
        this.darkenBodyLeft.beginFill(0x000000);

        this.darkenBodyLeft.moveTo(0, 0);
        this.darkenBodyLeft.arc(0, 0,  this.radius, 0,Math.PI, false);
        this.darkenBodyLeft.endFill();

        this.darkenBodyLeft.x=this.activeGameData.size[0]/2;
        this.darkenBodyLeft.y=this.activeGameData.size[1]/2;
        this.darkenBodyLeft.alpha=0;
        this.darkenBodyLeft.rotation=(-270)*Math.PI/180;//finale
        
        // this.darkenBodyRightsprite=


        this.darkenBodyLeftFadeTween=PIXI.tweenManager.createTween(this.darkenBodyLeft);//Spring Back before start
        this.darkenBodyLeftFadeTween.from({alpha:0}).to({alpha:.5});
        this.darkenBodyLeftFadeTween.time =this.animationDuration;
        this.darkenBodyLeftFadeTween.delay =0;//StartAfter 2 second
        this.darkenBodyLeftFadeTween.easing = PIXI.tween.Easing.outExpo();

        this.darkenBodyLeftMask = new PIXI.Graphics();
        this.darkenBodyLeftMask.beginFill(0x000000);
        this.darkenBodyLeftMask.drawRect(- this.radius, 0,  this.radius*2, this.radius);
        this.darkenBodyLeftMask.endFill();
        this.darkenBodyLeftMask.x=this.activeGameData.size[0]/2+2;
        this.darkenBodyLeftMask.y=this.activeGameData.size[1]/2;
        this.darkenBodyLeftMask.rotation=Math.PI/180*(-90);
        
        this.darkenBodyLeftMaskTween=PIXI.tweenManager.createTween(this.darkenBodyLeftMask);//Spring Back before start
        this.darkenBodyLeftMaskTween.to({rotation:Math.PI/180*(-90+180-9),});
        this.darkenBodyLeftMaskTween.time =this.animationDuration;
        this.darkenBodyLeftMaskTween.delay =0;//StartAfter 2 second
        this.darkenBodyLeftMaskTween.easing = PIXI.tween.Easing.outExpo();
        // this.darkenBodyLeftMaskTween.expire=true;
         

        

        this.darkenBodyLeft.mask=this.darkenBodyLeftMask;

        this.parentContainer.addChild(this.darkenBodyLeft);        
        this.parentContainer.addChild(this.darkenBodyLeftMask);

        

        
        this.darkenBodyRight= new PIXI.Graphics();
        this.darkenBodyRight.beginFill(0x000000);
            //  this.darkenBodyRight.clear();
        // this.darkenBodyRight.lineStyle(6, 0xffffff, 1);
        this.darkenBodyRight.moveTo(0, 0);
        this.darkenBodyRight.arc(0, 0,  this.radius, 0,Math.PI, false);
        this.darkenBodyRight.endFill();

        this.darkenBodyRight.x=this.activeGameData.size[0]/2;
        this.darkenBodyRight.y=this.activeGameData.size[1]/2;
        this.darkenBodyRight.rotation=(-90)*Math.PI/180;//finale
        this.darkenBodyRight.alpha=0;


        this.darkenBodyRightFadeTween=PIXI.tweenManager.createTween(this.darkenBodyRight);//Spring Back before start
        this.darkenBodyRightFadeTween.from({alpha:0}).to({alpha:.5});
        this.darkenBodyRightFadeTween.time =2000;
        this.darkenBodyRightFadeTween.delay =0;//StartAfter 2 second
        this.darkenBodyRightFadeTween.easing = PIXI.tween.Easing.outExpo();

        this.darkenBodyRightMask = new PIXI.Graphics();
        this.darkenBodyRightMask.beginFill(0x000000);
        this.darkenBodyRightMask.drawRect(- this.radius, 0,  this.radius*2, this.radius);
        this.darkenBodyRightMask.endFill();
        this.darkenBodyRightMask.x=this.activeGameData.size[0]/2-2;
        this.darkenBodyRightMask.y=this.activeGameData.size[1]/2;
        this.darkenBodyRightMask.rotation=Math.PI/180*(-270);
        
        this.darkenBodyRightMaskTween=PIXI.tweenManager.createTween(this.darkenBodyRightMask);//Spring Back before start
        this.darkenBodyRightMaskTween.to({rotation:Math.PI/180*(-270-180+9-0.2)});
        this.darkenBodyRightMaskTween.time =2000;
        this.darkenBodyRightMaskTween.delay =0;//StartAfter 2 second
        this.darkenBodyRightMaskTween.easing = PIXI.tween.Easing.outExpo();
        // this.darkenBodyRightMaskTween.expire=true;
        // this.darkenBodyRightMaskTween.start();
          this.darkenBodyRight.mask=this.darkenBodyRightMask;

          this.parentContainer.addChild(this.darkenBodyRight);        
          this.parentContainer.addChild(this.darkenBodyRightMask);
         

    }
    public setParent=(parent:PIXI.Container):void=>
    {
        parent.addChild( this.parentContainer)
    }
    public setStartAnimationDegree(angle:number)    
    {   
        // console.log(this.darkenBodyLeftMask.rotation)
        this.darkenBodyLeftMaskTween.to({rotation:Math.PI/180*(-90+180-angle)});
        this.darkenBodyLeftMaskTween.reset();  
        this.darkenBodyLeftMaskTween.start(); 

        this.darkenBodyRightMaskTween.to({rotation:Math.PI/180*(-270-180+angle)});
        this.darkenBodyRightMaskTween.reset();  
        this.darkenBodyRightMaskTween.start();  
        // console.log(this.darkenBodyLeft.alpha);
        this.fadeInBlack();
        // if (this.darkenBodyLeft.alpha===0){this.darkenBodyLeft.alpha=.5; this.darkenBodyRight.alpha=.5;}
    }    
    private fadeOutBlack=():void=>
    {   
        
        this.darkenBodyLeftFadeTween.from({alpha:.5}).to({alpha:0});
        this.darkenBodyLeftFadeTween.reset();
        this.darkenBodyLeftFadeTween.start();

        this.darkenBodyRightFadeTween.from({alpha:.5}).to({alpha:0});
        this.darkenBodyRightFadeTween.reset();
        this.darkenBodyRightFadeTween.start();

      
    }
    private fadeInBlack=():void=>
    {   
        
        this.darkenBodyLeftFadeTween.from({alpha:0}).to({alpha:0.5});
        this.darkenBodyLeftFadeTween.reset();
        this.darkenBodyLeftFadeTween.start();

        this.darkenBodyRightFadeTween.from({alpha:0}).to({alpha:0.5});
        this.darkenBodyRightFadeTween.reset();
        this.darkenBodyRightFadeTween.start();
      
    }

    public setFadeInOutBlack=(bool:boolean):void=>
    {
        if(bool)
        {
            this.fadeInBlack();
        }
        else
        {
            this.fadeOutBlack();
        }
    }


    
    private setDefaultZero=():void=>
    {
        this.setStartAnimationDegree(0);   
    }
    public setDefaultRotation()
    {   
        this.darkenBodyLeft.rotation=(-270)*Math.PI/180;//finale
        this.darkenBodyLeftMask.rotation=Math.PI/180*(-90);
        this.darkenBodyRight.rotation=(-90)*Math.PI/180;//finale
        this.darkenBodyRightMask.rotation=Math.PI/180*(-270);
        this.setDefaultZero();
    }  
    public setDuration=(durationTime:number):void=>
    {  
        this.darkenBodyLeftMaskTween.time =durationTime;
        this.darkenBodyLeftMaskTween.time =durationTime;
        this.darkenBodyRightMaskTween.time =durationTime;
        this.darkenBodyRightMaskTween.time =durationTime;

    }

    public setDefault=():void=>
    {
        this.setDuration(1);
        this.setDefaultZero();
        this.fadeInBlack();
    }
    public getFadeTween=():PIXI.tween.Tween=>
    {
        return this.darkenBodyLeftFadeTween
    }
}